module.exports = __webpack_public_path__ + "img/63584B_E6E0D6_A8A092_BFB6A8-256px.38d33f81.png";